import React from "react";
import HeaderLinks from "routes/HeaderLinks";

const HeaderNav = () => {
  return (
    <nav className="navHeader">
      <HeaderLinks />
    </nav>
  );
};

export default HeaderNav;
